import { render, staticRenderFns } from "./SettingsKnowledge.vue?vue&type=template&id=03555d1a&scoped=true"
import script from "./SettingsKnowledge.vue?vue&type=script&lang=js"
export * from "./SettingsKnowledge.vue?vue&type=script&lang=js"
import style0 from "./SettingsKnowledge.vue?vue&type=style&index=0&id=03555d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03555d1a",
  null
  
)

export default component.exports